const tradeShowsLinks = {
  importanceOfDigitalMaps:
    "https://resources.mappedin.com/blog/the-importance-of-digital-maps-for-trade-shows-and-exhibitions",
  indoorNavigationSystems:
    "https://resources.mappedin.com/blog/indoor-navigation-systems-for-trade-shows-and-exhibitions",
}

const indoorMappingLinks = {
  // Blog posts
  createMaps: "https://resources.mappedin.com/blog/create-maps",
  maintainingMaps: "https://resources.mappedin.com/blog/maintaining-maps",
  product101MapEditor:
    "https://resources.mappedin.com/blog/product-101-map-editor",
  // Functions of the CMS
  choosingMappingProvider:
    "https://f.hubspotusercontent10.net/hubfs/6215563/Case%20Studies/12%20Things%20To%20Consider%20When%20Choosing%20An%20Indoor%20Mapping%20Provider.pdf",
}

const indoorPositioningLinks = {
  indoorPositioningVsIndoorNavigation:
    "https://resources.mappedin.com/blog/indoor-positioning-vs-indoor-navigation",
  whatIsBlueDotWayfinding:
    "https://resources.mappedin.com/blog/what-is-blue-dot-wayfinding",
  useCasesForBlueDotWayfinding:
    "https://resources.mappedin.com/blog/9-use-cases-for-blue-dot-wayfinding",
}

const campusLinks = {
  howToUseIndoorMapping:
    "https://resources.mappedin.com/blog/how-to-use-indoor-mapping-at-your-college-or-university",
  benefitsOfInteractiveCampusMaps:
    "https://resources.mappedin.com/blog/the-benefits-of-interactive-campus-maps",
  implementingSuccessfulCampusNavigationApp:
    "https://resources.mappedin.com/blog/implementing-a-successful-campus-navigation-app",
}

const transportationBlogLinks = {
  indoorNavigation:
    "https://resources.mappedin.com/blog/the-importance-of-an-indoor-navigation-system-for-airports",
  digitalMapping:
    "https://resources.mappedin.com/blog/why-your-train-station-needs-a-digital-mapping-solution",
  useCases:
    "https://resources.mappedin.com/blog/9-use-cases-for-indoor-positioning-at-an-airport",
}

const healthcareBlogLinks = {
  indoorNavigationImprovingPatientExperience:
    "https://resources.mappedin.com/blog/indoor-navigation-in-hospitals-improving-the-patient-experience",
  benefitsToUsingIndoorMaps:
    "https://resources.mappedin.com/blog/16-benefits-to-using-indoor-maps-in-hospitals",
  guideToIndoorOutdoorNavigation:
    "https://resources.mappedin.com/blog/guide-to-indoor-outdoor-navigation-system-for-hospitals-and-healthcare-institutions",
}

const publicSafetyLinks = {
  importanceOfEmergencyMappingSoftware:
    "https://www.mappedin.com/blog/use-cases/safety/the-importance-of-emergency-mapping-software/",
  guideToFireDepartmentPreplanSoftware:
    "https://www.mappedin.com/blog/use-cases/safety/your-guide-to-fire-department-preplan-software/",
  indoorMappingImprovesEmergencyPlanning:
    "https://www.mappedin.com/blog/use-cases/safety/indoor-mapping-improves-emergency-planning/",
}

// This does not include the single reference to our job positing api in the careers page, or the vimeo direct links
const hubspotLinks = {
  contactFormSubmissionApi:
    "https://api.hsforms.com/submissions/v3/integration/submit/6215563/33b6de3f-0501-4ed8-ae1a-1d939dd4b048",
  emailFooterSubmissionApi:
    "https://api.hsforms.com/submissions/v3/integration/submit/6215563/38cd9172-9fde-4022-b7ce-0fb91977558f",
  partnerFormSubmissionApi:
    "https://api.hsforms.com/submissions/v3/integration/submit/6215563/687783cc-fefb-4c2e-a082-43920871d4b5",
  blog: "https://resources.mappedin.com/blog",
  learn: "https://resources.mappedin.com/learn",
  newsroom: "https://resources.mappedin.com/newsroom",
  privacyPolicy: "https://info.mappedin.com/privacy-policy",
  terms: "http://info.mappedin.com/terms-and-conditions/",
  accessibility: "https://info.mappedin.com/accessibility-commitment-statement",
  createMaps: "https://resources.mappedin.com/blog/create-maps",
  designMaps:
    "https://resources.mappedin.com/blog/designing-indoor-maps-for-different-use-cases",
  product101CMS: "https://resources.mappedin.com/blog/product-101-mappedin-cms",
  product101Web: "https://resources.mappedin.com/blog/product-101-mappedin-web",
  product101Directory:
    "https://resources.mappedin.com/blog/product-101-digital-directory",
  product101DirectoryRedesign:
    "https://resources.mappedin.com/blog/product-101-digital-directory-redesign",
  product101Export:
    "https://resources.mappedin.com/blog/product-101-imdf-export",
  product101DraftPublish:
    "https://resources.mappedin.com/blog/product-101-draft-publish-mode",
  product101Voice:
    "https://resources.mappedin.com/blog/feature-101-directory-voice-assist",
  productImdfExport:
    "https://resources.mappedin.com/blog/product-101-imdf-export",
  verticalStadiumsBlogEnhance:
    "https://resources.mappedin.com/blog/4-ways-to-enhance-the-stadium-experience-with-digital-maps",
  verticalStadiumsBlogIndoor:
    "https://resources.mappedin.com/blog/using-indoor-maps-to-create-a-stadium-experience",
  verticalStadiumsBlogWayfinding:
    "https://resources.mappedin.com/blog/7-ways-digital-wayfinding-can-improve-the-customer-experience",
  verticalMallsEbook:
    "https://resources.mappedin.com/learn/e-book-re-inventing-retail",
  verticalMallsBlogBenefits:
    "https://resources.mappedin.com/blog/improving-your-shopping-malls-with-indoor-mapping",
  verticalMallsBlogReturn:
    "https://resources.mappedin.com/blog/return-to-retail",
  verticalMallsBlogSatisfi:
    "https://resources.mappedin.com/blog/mappedin-satisfi-labs-integration",
  verticalRetailBlog:
    "https://resources.mappedin.com/blog/4-advantages-to-using-digital-maps-in-retail-stores",
  verticalGroceryBlog:
    "https://resources.mappedin.com/blog/5-reasons-to-use-digital-maps-in-grocery-stores",
  verticalGroceryBlogImproves:
    "https://resources.mappedin.com/blog/grocery-store-picking-and-packing-best-practices",
  verticalGroceryBlogLoblaw:
    "https://resources.mappedin.com/learn/loblaw-digital-optimizing-retail-wayfinding-for-time-savings",
  partnerServiceNowBlog:
    "https://resources.mappedin.com/blog/servicenow-and-mappedin-improving-the-employee-experience",
  partnerSdkBlog:
    "https://resources.mappedin.com/blog/partner-applications-of-mappedin-sdks",
  partnerThoughtWireBlog:
    "https://resources.mappedin.com/newsroom/thoughtwire-mappedin-partnership-provides-iot-informed-mapping-for-built-environments",
  securityCommitment:
    "https://resources.mappedin.com/blog/solidifying-our-commitment-to-the-highest-standard-of-data-security",
  securityFeatures:
    "https://resources.mappedin.com/blog/new-mappedin-features-that-enhance-security-practices",
  indoorPositioning: indoorPositioningLinks,
  campuses: campusLinks,
  warehousesPickingAndPacking:
    "https://resources.mappedin.com/blog/how-to-reduce-picking-and-packing-errors-in-warehouses",
  warehousesIndoorPositioning:
    "https://resources.mappedin.com/blog/using-indoor-positioning-to-increase-efficiency-in-warehouses",
  healthcare: healthcareBlogLinks,
  transportation: transportationBlogLinks,
  indoorMapping: indoorMappingLinks,
  tradeShows: tradeShowsLinks,
  publicSafety: publicSafetyLinks,
}

const externalLinks = {
  hubspot: hubspotLinks,
  instagram: "https://www.instagram.com/mappedinatwork/",
  facebook: "https://www.facebook.com/mappedin/",
  linkedin: "https://ca.linkedin.com/company/mappedin",
  twitter: "https://twitter.com/mappedin",
  iosSamples: "https://github.com/MappedIn/ios",
  webSamples: "https://github.com/MappedIn/platform-api",
  androidSamples: "https://github.com/MappedIn/android",
  iosDocs: "https://developer.mappedin.com/guides/ios/",
  webDocs: "https://developer.mappedin.com/guides/web/",
  androidDocs: "https://developer.mappedin.com/guides/android/",
  cms: "https://cms.mappedin.com",
  jobPostings:
    "https://96go6alv91.execute-api.us-west-2.amazonaws.com/Production",
  developerPortal: "https://developer.mappedin.com/",
}

export default externalLinks
